require.context('../../../ui/img/', true, /\.(gif|png|jpe?g|svg)$/i);

window['redirectToUrl'] = function(game, terminal = false) {

    window['token'] = getUrlParam('token');
    window['lang'] = getUrlParam('lang') !== null ? getUrlParam('lang') : 'en';
    
    if (!terminal) {
        if (getUrlParam('backUrl')) {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang + '&backUrl=' + getUrlParam('backUrl');
        } else {
            window.location.href = game + '/index.html?token=' + token + '&lang=' + lang;
        }
    } else {
        window.location.href = game + '/terminal.html?token=' + token + '&lang=' + lang;
    }
}


window['renderMenu'] = function() {

    let gamesToRender = getAvailableGames();

    if(!document.querySelector('#sidebar')) {

        let element = document.querySelector('#terminal-sidebar');
        // check numbers from GAMES global
        const enabledGames = [1,2,8];
        let html = '';

        gamesToRender.forEach((game) => {
            return html +=
            `<li class="${window.location.href.indexOf(GAMES[game].url) > -1 ? 
                'active' : enabledGames.includes(Number(game)) ? 'active borderless' : 'transparentz'}" ><a href="javascript: void(0)" ${enabledGames.includes(Number(game)) ? `onclick="redirectToUrl('${BASE_URL + GAMES[game].url}', true)"` : ''} ${game != 1 ? 
                    'disabled' : 
                        ''}><img alt="dog-racing" src='../shared/img/${GAMES[game].url}.png'/><span>${GAMES[game].name}</span></a></li>`;   
        });

        element.innerHTML = html;
    } else {
        let element = document.querySelector('#sidebar');
        let html = '';

        gamesToRender.forEach((game) => {
            return html +=
                `<li>
                <a class="${window.location.href.indexOf(GAMES[game].url) > -1 ? 'active' : ''}"  
                href="javascript: void(0)" onclick="redirectToUrl('${BASE_URL + GAMES[game].url}')">` +
                `<img alt="${GAMES[game].url}"  src='../shared/img/${GAMES[game].url}.png' /><span>${GAMES[game].name}</span></a>` +
                `</li>`;
        });

        element.innerHTML = html;
    }
}

/**
 * Gets game numbers as array from api response.
 *
 * @return array
 */
function getAvailableGames() {
    var responseGames = window['menu'].split('|');
    var availableGames = responseGames.filter(function(val) {
        return Object.keys(GAMES).indexOf(val) != -1;
    });
    return availableGames;
}


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/js/menu.js
// module id = 2389
// module chunks = 5